module.exports = __webpack_public_path__ + "static/media/btn-next_dark.7410a59e.svg";